import React, { useEffect } from 'react'

import './fronthand_style.css';
import './fronthand_media-queries.css';


import logo from './assets_1/logo.png';


import { Roi, Usdt_Token, Withdraw, DateTime } from './Data_Structure';


export default function BnbPro_Before_Login(props) {
    
    return (
        <>
            {/* <main> */}
                {/* <div class="f-main-content">
                    <section>
                        <div class="f-card">
                            <div class="f-card-header f-font-color">
                                <h3>Welcome</h3>
                            </div> 
                            <div class="f-card-miiddle">
                                <span><img src={logo} alt=""/></span>
                            </div>
                            <div class="f-card-quotes">
                                <span>The future of leverage is here.</span>
                            </div>
                            <div class="f-card-connect-btn">
                                <button onClick={() => {props.SignIn_Click()}}>Connect Wallet<span class=""></span></button>
                            </div>
                        </div>
                    </section>
                </div>               */}
    
                <div class="f-main-content">
                    <section>
                        <div class="f-card">
                            <div class="f-card-header f-font-color">
                                <h3>Welcome</h3>
                            </div> 
                            <div class="f-card-miiddle">
                                <span><img src={logo} alt=""/></span>
                            </div>
                            <div class="f-card-quotes">
                                <span>The future of leverage is here.</span>
                            </div>
                            <div class="f-card-connect-btn">
                                <button onClick={() => {props.SignIn_Click()}}>Connect Wallet<span></span></button>
                                <button onClick={() => {props.SignUp_Click()}}>SignUp<span></span></button>
                            </div>
                        </div>
                    </section>
                </div>  
            {/* </main> */}
        </>
    );
}
